import { useState, useEffect } from 'react';
import { fetchCachedSvg, getCachedSvg } from '../utils/svgCache';

/**
 * Returns a cached data URI for an SVG avatar URL.
 * Shows the cached version immediately if available, otherwise fetches and caches.
 */
export function useCachedSvg(url: string | undefined): string | undefined {
  const [dataUri, setDataUri] = useState<string | undefined>(
    url ? getCachedSvg(url) : undefined,
  );

  useEffect(() => {
    if (!url) {
      setDataUri(undefined);
      return;
    }

    // Check cache synchronously first
    const cached = getCachedSvg(url);
    if (cached) {
      setDataUri(cached);
      return;
    }

    let cancelled = false;
    fetchCachedSvg(url).then((result) => {
      if (!cancelled) setDataUri(result);
    });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return dataUri;
}
